import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ToggleButton } from '../../UI';

interface PropTypes {
  onSave: ({
    soundEnabled,
    notificationsEnabled,
    chatRoomId,
  }: {
    soundEnabled: boolean;
    notificationsEnabled: boolean;
    chatRoomId?: string;
  }) => void;
  soundEnabled: boolean;
  notificationsEnabled: boolean;
  chatRoomId?: string;
}

const SettingsModal: React.FC<PropTypes> = ({
  onSave,
  soundEnabled,
  notificationsEnabled,
  chatRoomId,
}) => {
  const { t } = useTranslation();

  const [state, setState] = useState({ soundEnabled, notificationsEnabled });

  return (
    <div className="p-12 px-36 m-auto text-center">
      <h2 className="font-bold text-center text-lg">
        {t('chatroom.settingsModal.title')}
      </h2>
      <div className="flex justify-between py-4 border-b-1 border-grey-10">
        <span className="pr-36">{t('chatroom.settingsModal.chatSound')}</span>
        <ToggleButton
          activatedLabel="On"
          deactivatedLabel="Off"
          renderLabelOn="left"
          isActivated={state.soundEnabled}
          onActivate={() =>
            setState((prevState) => ({
              ...prevState,
              soundEnabled: true,
            }))
          }
          onDeactivate={() =>
            setState((prevState) => ({
              ...prevState,
              soundEnabled: false,
            }))
          }
        />
      </div>
      <div className="flex justify-between py-4 border-b-1 border-grey-10">
        <span className="pr-36">{t('chatroom.settingsModal.mentions')}</span>
        <ToggleButton
          activatedLabel="On"
          deactivatedLabel="Off"
          renderLabelOn="left"
          isActivated={state.notificationsEnabled}
          onActivate={() =>
            setState((prevState) => ({
              ...prevState,
              notificationsEnabled: true,
            }))
          }
          onDeactivate={() =>
            setState((prevState) => ({
              ...prevState,
              notificationsEnabled: false,
            }))
          }
        />
      </div>
      <div className="flex justify-center pt-8">
        <Button
          type="button"
          variant="primary"
          onClick={() => onSave({ chatRoomId, ...state })}
        >
          {t('chatroom.settingsModal.save')}
        </Button>
      </div>
    </div>
  );
};

export default SettingsModal;
